"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTargetBlank = exports.isLinkInternal = exports.isLinkExternal = exports.isExcludedPath = exports.isDownloadFile = exports.isDocumentPath = void 0;
var _common = require("../config/common");
var _array = require("./type-checks/array");
var _object = require("./type-checks/object");
var _string = require("./type-checks/string");
/**
 * Checks path to see if the link is internal relative to hostname
 *
 * @name isDownloadFile
 * @param {string} Path to test
 * @returns {boolean} Indicator if link is internal
 */
const isDownloadFile = path => {
  let isDownloaded = false;
  if ((0, _string.isStringOfLength)(path)) {
    _common.DOWNLOAD_FILE_EXTENSIONS.forEach(value => {
      let fileReg;
      if (!isDownloaded) {
        // eslint-disable-next-line no-useless-escape
        fileReg = new RegExp(`\\.${value}$`, "i");
        isDownloaded = fileReg.test(path);
      }
    });
  }
  return isDownloaded;
};

/**
 * Checks path to see if the link is internal relative to hostname
 *
 * @name isLinkInternal
 * @param {string} Path to test
 * @returns {boolean} Indicator if link is internal
 */
exports.isDownloadFile = isDownloadFile;
const isLinkInternal = path => {
  const base = new URL(`${window.location.protocol}//${window.location.host}`);
  return new URL(path, base).hostname === base.hostname;
};

/**
 * Checks path to see if the link is external relative to hostname
 *
 * @name isLinkExternal
 * @param {string} Path to test
 * @returns {boolean} Indicator if link is external
 */
exports.isLinkInternal = isLinkInternal;
const isLinkExternal = path => !isLinkInternal(path);

/**
 * Check to see if the path contains a excluded folder match
 *
 * @name isExcludedPath
 * @param {path} Path to test for matches
 * @param {excludedDirs} Array of regular expressions to test
 * @returns {boolean} Indicator if an excluded pattern was found
 */
exports.isLinkExternal = isLinkExternal;
const isExcludedPath = (path, excludedDirs) => {
  let result = true;
  if ((0, _string.isStringOfLength)(path) && (0, _array.isArrayOfLength)(excludedDirs)) {
    result = excludedDirs.every(dirTest => {
      let expression,
        thisResult = true;
      if ((0, _string.isStringOfLength)(dirTest)) {
        expression = new RegExp(dirTest);
        thisResult = !expression.test(path);
      } else if ((0, _object.isObject)(dirTest) && dirTest.constructor === RegExp) {
        thisResult = !dirTest.test(path);
      }
      return thisResult;
    });
  }
  return !result;
};

/**
 * Checks object to see if it has a target="_blank" attribute/property
 *
 * @name isTargetBlank
 * @param {elem} Element Anchor Element to test for target="_blank"
 * @returns {boolean} Indicator if an excluded pattern was found
 */
exports.isExcludedPath = isExcludedPath;
const isTargetBlank = elem => {
  return (0, _object.isObject)(elem) && (0, _string.isStringOfLength)(elem.target) && elem.target.toLowerCase() === "_blank";
};

/**
 * Checks path to see if it directs to a document
 *
 * @name isDocumentPath
 * @param {string} Path to test
 * @returns {boolean} Indicator if an excluded pattern was found
 */
exports.isTargetBlank = isTargetBlank;
const isDocumentPath = path => {
  const regExpDocs = /\.pdf|\.doc|\.xls|\.ppt/i;
  return regExpDocs.test(path);
};
exports.isDocumentPath = isDocumentPath;